/**
 * Format a byte count into a compact, human-readable string such as
 * "3.4 MB". Used to expose file size information to assistive
 * technology in file chip accessible names.
 */
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

const formatFileSize = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return '';
  }

  if (bytes === 0) {
    return '0 B';
  }

  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    UNITS.length - 1
  );
  const value = bytes / 1024 ** exponent;
  // Whole numbers avoid a spurious trailing ".0"; otherwise show a single
  // decimal for compactness.
  const formatted =
    exponent === 0 || value >= 100 || Number.isInteger(value)
      ? Math.round(value).toString()
      : value.toFixed(1);

  return `${formatted} ${UNITS[exponent]}`;
};

export default formatFileSize;
